// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1IYX9","rootNoMargin":"styles_rootNoMargin__222aK"};